module.exports = __webpack_public_path__ + "img/main.158b9118.jpg";